import Icon, { IconName } from "@repo/ui/components/ui/icon/icon";
import { cn } from "@repo/ui/lib/utils";
import { Dispatch, SetStateAction, useEffect } from "react";

export default function Toast({
  label,
  icon,
  visible,
  setIsVisible,
  timeout = 5000,
}: {
  label: string;
  icon?: IconName;
  visible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  timeout?: number;
}) {
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(false), timeout);
    return () => clearTimeout(timer);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={cn(
        "top-[130px] max-md:top-[110px] fixed w-[50%] max-md:w-[80%] left-[50%] translate-x-[-50%] z-50 bg-secondary-green gap-4 rounded-full flex px-[40px] max-md:p-[20px] py-[20px] transform transition-all duration-300 ease-in-out",
        "font-bold items-center text-primary-white text-[16px] max-md:text-[12px] outline outline-[2px] outline-[#00D885]",
      )}
    >
      {icon && (
        <Icon className="fill-primary-white h-[24px] w-[24px]" icon={icon} />
      )}
      {label}
    </div>
  );
}
